export default __webpack_public_path__ + "static/media/mbGo.fd0005b4.png";